import InfoboxOverlay, { IProps } from './InfoboxOverlay';

export default InfoboxOverlay;
export { IProps as InfoboxOverlayProps };
